import React from 'react';
import { Button, Divider } from 'semantic-ui-react';

const TableHeader = (props) => {
  return (
    <div>
      <Button
        content='Add new event'
        onClick={props.onOpen}/>
      <Divider hidden />
    </div>
  );
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/private/admin/components/Events/Header.js